import { Lightbulb } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SuggestionsSectionProps {
  suggestions: string[];
}

// Mock coaching suggestions
// const _coachingSuggestions = [
//   {
//     type: "immediate",
//     icon: AlertTriangle,
//     title: "Active Listening Opportunity",
//     description:
//       "Genevieve is sharing concerns - try paraphrasing to show understanding",
//     priority: "high",
//   },
//   {
//     type: "technique",
//     icon: Lightbulb,
//     title: "SPIN Selling Framework",
//     description:
//       "Guide her to ask more situation and problem questions before presenting solutions",
//     priority: "medium",
//   },
//   {
//     type: "progress",
//     icon: TrendingUp,
//     title: "Confidence Building",
//     description:
//       "Acknowledge her improvement in objection handling from last session",
//     priority: "low",
//   },
// ];

const SuggestionsSection = ({ suggestions }: SuggestionsSectionProps) => {
  return (
    <Card className="border-gray-600 bg-gray-700">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-sm text-gray-200">
          <Lightbulb className="size-4" />
          Coaching Suggestions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {!suggestions || suggestions.length === 0 ? (
          <div className="flex items-center justify-center rounded-lg border border-gray-600/30 bg-gray-800/60 p-4 text-sm text-gray-400">
            No suggestions yet.
          </div>
        ) : (
          suggestions.map((suggestion, index) => {
            const IconComponent = Lightbulb;
            const priority = index === 10 ? "high" : "medium";
            return (
              <div
                key={index}
                className={`rounded-lg border p-3 transition-all duration-200 ${
                  priority === "high"
                    ? "border-red-600/30 bg-red-900/20"
                    : priority === "medium"
                      ? "border-amber-600/30 bg-amber-900/20"
                      : "border-blue-600/30 bg-blue-900/20"
                }`}
              >
                <div className="flex items-start gap-3">
                  <IconComponent
                    className={`mt-0.5 size-4 ${
                      priority === "high"
                        ? "text-red-400"
                        : priority === "medium"
                          ? "text-amber-400"
                          : "text-blue-400"
                    }`}
                  />
                  <div className="flex-1">
                    {/* <h4 className="mb-1 text-sm font-medium text-gray-200">
                      {suggestion.title}
                    </h4> */}
                    <p className="text-xs leading-relaxed text-gray-300">
                      {suggestion}
                    </p>
                    <Badge
                      variant="outline"
                      className={`mt-2 text-xs ${
                        priority === "high"
                          ? "border-red-600/30 text-red-400"
                          : priority === "medium"
                            ? "border-amber-600/30 text-amber-400"
                            : "border-blue-600/30 text-blue-400"
                      }`}
                    >
                      {priority} priority
                    </Badge>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </CardContent>
    </Card>
  );
};

export default SuggestionsSection;
